import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=3b912fac&scoped=true&"
var script = {}
import style0 from "./loader.vue?vue&type=style&index=0&id=3b912fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b912fac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b912fac')) {
      api.createRecord('3b912fac', component.options)
    } else {
      api.reload('3b912fac', component.options)
    }
    module.hot.accept("./loader.vue?vue&type=template&id=3b912fac&scoped=true&", function () {
      api.rerender('3b912fac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/general/loader.vue"
export default component.exports